// animations.optimized.js

const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// ===== Scroll animation logic =====
function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const el = entry.target;
    if (entry.isIntersecting) {
      if (el.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        el.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (el.hasAttribute('data-cascade')) el.style.setProperty('--animation-order', index);
      }
      observer.unobserve(el);
    } else {
      el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      el.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignMode = false) {
  const elements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (!elements.length) return;

  if (isDesignMode) {
    elements.forEach((el) => el.classList.add('scroll-trigger--design-mode'));
    return;
  }

  const observer = new IntersectionObserver(onIntersection, { rootMargin: '0px 0px -50px 0px' });
  elements.forEach((el) => observer.observe(el));
}

// ===== Zoom-in animation logic (deferred) =====
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const elements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (!elements.length) return;

  const scaleAmount = 0.002; // 0.2 / 100

  elements.forEach((el) => {
    let isVisible = false;

    const observer = new IntersectionObserver((entries) => {
      isVisible = entries.some((entry) => entry.isIntersecting);
    });
    observer.observe(el);

    function updateZoom() {
      if (!isVisible) return;
      el.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(el));
    }

    // Trigger initially
    updateZoom();

    // Only attach scroll listener if element is visible
    window.addEventListener('scroll', throttle(updateZoom, 50), { passive: true });
  });
}

function percentageSeen(el) {
  const vh = window.innerHeight;
  const scrollY = window.scrollY;
  const top = el.getBoundingClientRect().top + scrollY;
  const height = el.offsetHeight;

  if (top > scrollY + vh) return 0;
  if (top + height < scrollY) return 100;

  const distance = scrollY + vh - top;
  const percentage = distance / ((vh + height) / 100);
  return Math.round(percentage);
}

// ===== Simple throttle =====
function throttle(fn, wait) {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last >= wait) {
      last = now;
      fn(...args);
    }
  };
}

// ===== Initialize animations only when DOM content is loaded =====
document.addEventListener('DOMContentLoaded', () => {
  // Scroll animations critical
  initializeScrollAnimationTrigger();

  // Lazy load zoom-in animations after slight delay
  setTimeout(() => {
    initializeScrollZoomAnimationTrigger();
  }, 300);
});

// ===== Shopify designMode support =====
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
